import type { CatalogItem } from '../../client/SkillClient';
import type { Locale } from '../../i18n/resources';

type Described = Pick<CatalogItem, 'description' | 'displayDescriptionZh' | 'displayDescriptionEn'>;

/**
 * The card text for a skill in the UI locale: the author's display
 * description for that locale (SKILL.md metadata.display_description), else
 * the skill's `description`, which is what the agent reads and may be in
 * either language.
 */
export function skillDescription(item: Described, locale: Locale): string {
  const display = locale === 'en' ? item.displayDescriptionEn : item.displayDescriptionZh;
  return display?.trim() || item.description || '';
}

/** Every description of a skill, so the marketplace search finds it in either language. */
export function skillSearchText(item: Described): string {
  return [item.displayDescriptionZh, item.displayDescriptionEn, item.description].filter(Boolean).join('\n');
}
